import React from 'react'
import { DocumentImport16, TrashCan16, DocumentExport16 } from '@carbon/icons-react'
import './index.scss'
import { TYPE_AVATAR } from './constants'

const Avatar = ({ text, src, type }) => {

  const renderAvatar = () => {
    if (type === TYPE_AVATAR.EXPORT) {
      return <DocumentExport16/>
    }
    if (type === TYPE_AVATAR.IMPORT) {
      return <DocumentImport16/>
    }
    if (type === TYPE_AVATAR.DELETE) {
      return <TrashCan16/>
    }

    return <span>{text}</span>
  }

  return (
    <div className='ublique-avatar'>
      {src ? <img src={src} alt='User avatar'/> : renderAvatar()}
    </div>

  )
}

export default Avatar
